module.exports = __webpack_public_path__ + "img/LoGoUfa.98ce4f5b.png";